/**
 * @module utils
 * @description 通用辅助函数
 * @author Yawei Wang
 * @date 2019-06-03 10:55:05
 */
import qs from 'qs';
/**
 * 获取文字的字符数量(中文及中文符号转化为2个字符)
 * @function
 * @param str {String} 文字信息
 */

export var getCharLen = function getCharLen(str) {
  // tslint:disable-next-line:no-if-statement
  if (str) {
    return str.replace(/[^\x00-\xff]/g, 'xx').length;
  } else {
    return 0;
  }
};
/**
 * 获取URL参数值
 * @function
 * @param {String} name 参数key
 * @param {String} path 路径
 */

export var getQueryString = function getQueryString(name, path) {
  if (path === void 0) {
    path = null;
  }

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var search = path || decodeURI(window.location.search);
  var r = search.substr(1).match(reg);

  if (r != null) {
    return unescape(r[2]);
  }

  return null;
};
/**
 * 格式化金钱， 加千位分隔符
 * @function
 * @param {*} val 金额
 * @param {*} isWan 是否显示万
 */

export var getMoney = function getMoney(val, isWan) {
  if (isWan && val >= 10000) {
    return val / 10000 + '万';
  } else {
    return val ? val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') : val;
  }
};
/**
 * 格式化文件大小
 * @function
 * @param {Number} val
 */

export var getSize = function getSize(val) {
  if (val < 1048576) {
    return (val / 1024).toFixed(2) + 'KB';
  } else {
    return (val / 1048576).toFixed(2) + 'MB';
  }
};

var isType = function isType(obj, type) {
  if (typeof obj !== 'object') {
    return false;
  }

  var typeString = Object.prototype.toString.call(obj); // tslint:disable-next-line: no-let

  var flag;

  switch (type) {
    case 'Array':
      flag = typeString === '[object Array]';
      break;

    case 'Date':
      flag = typeString === '[object Date]';
      break;

    case 'RegExp':
      flag = typeString === '[object RegExp]';
      break;

    default:
      flag = false;
  }

  return flag;
};

var getRegExp = function getRegExp(re) {
  var flags = '';
  if (re.global) flags += 'g';

  if (re.ignoreCase) {
    flags += 'i';
  }

  if (re.multiline) {
    flags += 'm';
  }

  return flags;
};
/**
 * 深克隆
 * @param {[type]} parent object 需要进行克隆的对象
 * @param deep 是否深克隆
 * @return {[type]}   深克隆后的对象
 */


var deepCloneFn = function deepCloneFn(parent) {
  // 维护两个储存循环引用的数组
  var parents = [];
  var children = [];

  var _clone = function _clone(parent) {
    if (parent === null) {
      return null;
    }

    if (typeof parent !== 'object') {
      return parent;
    }

    var child, proto;

    if (isType(parent, 'Array')) {
      // 对数组做特殊处理
      child = [];
    } else if (isType(parent, 'RegExp')) {
      // 对正则对象做特殊处理
      child = new RegExp(parent.source, getRegExp(parent));

      if (parent.lastIndex) {
        child.lastIndex = parent.lastIndex;
      }
    } else if (isType(parent, 'Date')) {
      // 对Date对象做特殊处理
      child = new Date(parent.getTime());
    } else {
      // 处理对象原型
      proto = Object.getPrototypeOf(parent); // 利用Object.create切断原型链

      child = Object.create(proto);
    } // 处理循环引用


    var index = parents.indexOf(parent);

    if (index !== -1) {
      // 如果父数组存在本对象,说明之前已经被引用过,直接返回此对象
      return children[index];
    }

    parents.push(parent);
    children.push(child); // tslint:disable-next-line:forin

    for (var i in parent) {
      // 递归
      // tslint:disable-next-line: no-object-mutation
      child[i] = _clone(parent[i]);
    }

    return child;
  };

  return _clone(parent);
};
/**
 * 深度克隆
 * @function
 * @param {Object} data 被克隆的数据
 */


export var deepCopy = deepCloneFn;
/**
 * 节流函数
 * @function
 * @param {Function} fn 被执行行数
 * @param {Number} wait 需要等待的时间(毫秒)
 * @param {Number} mustRun 多少毫秒必须执行一次
 */

export var throttle = function throttle(fn, wait, mustRun) {
  if (wait === void 0) {
    wait = 100;
  }

  if (mustRun === void 0) {
    mustRun = 1000;
  }

  var timeout = null;
  var start = new Date();
  return function () {
    var ctx = this;
    var args = arguments;
    var curTime = new Date();

    if (timeout) {
      clearTimeout(timeout);
    } // 如果达到了规定的触发时间间隔，触发 handler


    if (curTime.getTime() - start.getTime() >= mustRun) {
      fn.apply(ctx, args);
      start = curTime;
    } else {
      // 没达到触发间隔，重新设定定时器
      timeout = setTimeout(fn, wait);
    }
  };
};
/**
 * 延迟函数
 * @function
 * @param {Function} fn 被执行函数
 * @param {Number} delay 延迟时间（毫秒）
 */

export var debounce = function debounce(fn, delay) {
  if (delay === void 0) {
    delay = 100;
  }

  var timer = null;
  return function () {
    var _this = this;

    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      return fn.apply(_this, args);
    }, delay);
  };
};
/**
 * 获取本地图片预览地址
 * @function
 * @param {*} file 图片文件
 * @returns {string} url
 */

export var getObjectURL = function getObjectURL(file) {
  var url = null;

  if (window.createObjectURL !== undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }

  return url;
};
/**
 * 将连接字符串转化为a标签
 * @function
 * @param {string} str
 */

export var urlToLink = function urlToLink(str) {
  var re = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  str = str.replace(re, function (website) {
    return "<a href='" + website + "' target='_blank'>" + website + "</a>";
  });
  return str;
};
/**
 * 获取站点环境
 * @function
 * @description prod: 线上，beta: 预发布，test: 测试
 */

export var getSiteEnv = function getSiteEnv() {
  var origin = window.location.origin;
  var env = origin.includes('clouderwork') ? 'prod' : origin.includes('beta') ? 'beta' : origin.includes('cpic') ? 'cpic' : 'test';
  return env;
};
/**
 * @function
 * @description 判断是否mac系统 包含iphone
 */

export var isMac = function isMac() {
  return /macintosh|mac os x|darwin/i.test(navigator.userAgent.toLowerCase());
};
/**
 * @function
 * @description 判断是否window系统
 */

export var isWindow = function isWindow() {
  return /windows|win32/i.test(navigator.userAgent.toLowerCase());
};
/**
 * 获取域名前缀
 * @function
 * @param {string} key 类型: resident：黄豆，yunxun：沃客信, ent: 企业版，monitor： 效率监控,org: 组织机构, crm：crm客户管理，appraise：估价器，passport：单点登录，task：任务管理系统，wssent：企业版socket链接地址，wsstask：任务管理socket链接地址，wssresident：黄豆socket链接地址，www: 主站地址，wwwm: 主站m站地址，file: 文件地址。
 * @param {string} [_env] 测试环境：test 预发布环境：beta 生产环境：prod
 */

export var getSitePreUrl = function () {
  var config = {
    prod: {
      resident: 'https://zhaopin.clouderwork.com',
      yunxun: 'https://i.clouderwork.com',
      ent: 'https://e.clouderwork.com',
      oss: 'https://oss.clouderwork.com',
      monitor: 'https://em.clouderwork.com',
      org: 'https://org.clouderwork.com',
      oahub: 'https://oahub.clouderwork.com',
      crm: 'https://crm2.clouderwork.com',
      appraise: 'https://appraise.clouderwork.com',
      passport: 'https://passport.clouderwork.com',
      task: 'https://task.clouderwork.com',
      www: 'https://www.clouderwork.com',
      wwwm: 'https://m.clouderwork.com',
      edoc: 'https://edoc.clouderwork.com',
      wssent: 'wss://e.clouderwork.com/api/feeds/ws',
      wsstask: 'wss://task.clouderwork.com/api/feeds/ws',
      wssresident: 'wss://zhaopin.clouderwork.com/websocket/feeds',
      eam: 'https://eam.clouderwork.com',
      news: 'https://info.clouderwork.com',
      file: 'https://ifile.clouderwork.com',
      code: 'https://code.clouderwork.com',
      app: 'https://app.clouderwork.com'
    },
    beta: {
      resident: 'https://beta-resident.yunwoke.com',
      yunxun: 'https://beta-yunxun.yunwoke.com',
      ent: 'https://beta-ent.yunwoke.com',
      oss: 'https://beta-oss.yunwoke.com',
      monitor: 'https://beta-monitor.yunwoke.com',
      org: 'https://beta-org.yunwoke.com',
      oahub: 'https://beta-oahub.yunwoke.com',
      crm: 'https://beta-crm2.yunwoke.com',
      appraise: 'https://beta-appraise.yunwoke.com',
      passport: 'https://beta-passport.yunwoke.com',
      task: 'https://beta-task.yunwoke.com',
      www: 'https://beta.yunwoke.com',
      wwwm: 'https://beta-m.yunwoke.com',
      edoc: 'https://beta-edoc.yunwoke.com',
      wssent: 'wss://beta-ent.yunwoke.com/api/feeds/ws',
      wsstask: 'wss://beta-task.yunwoke.com/api/feeds/ws',
      wssresident: 'wss://beta-resident.yunwoke.com/websocket/feeds',
      eam: 'https://beta-eam.yunwoke.com',
      news: 'https://beta-info.yunwoke.com',
      file: 'https://yunxunfile.yunwoke.com',
      code: 'https://beta-code.yunwoke.com',
      app: 'https://beta-app.yunwoke.com'
    },
    cpic: {
      resident: 'https://cpic-resident.yunwoke.com',
      yunxun: 'https://cpic-yunxun.yunwoke.com',
      ent: 'https://cpic-ent.yunwoke.com',
      oss: 'https://cpic-oss.yunwoke.com',
      monitor: 'https://cpic-monitor.yunwoke.com',
      org: 'https://cpic-org.yunwoke.com',
      oahub: 'https://cpic-oahub.yunwoke.com',
      crm: 'https://cpic-crm2.yunwoke.com',
      appraise: 'https://cpic-appraise.yunwoke.com',
      passport: 'https://cpic-monitor-passport.yunwoke.com',
      task: 'https://cpic-task.yunwoke.com',
      www: 'https://cpic.yunwoke.com',
      wwwm: 'https://cpic-m.yunwoke.com',
      edoc: 'https://cpic-edoc.yunwoke.com',
      wssent: 'wss://cpic-ent.yunwoke.com/api/feeds/ws',
      wsstask: 'wss://cpic-task.yunwoke.com/api/feeds/ws',
      wssresident: 'wss://cpic-resident.yunwoke.com/websocket/feeds',
      eam: 'https://cpic-eam.yunwoke.com',
      news: 'https://cpic-info.yunwoke.com',
      file: 'https://yunxunfile.yunwoke.com',
      code: 'https://cpic-code.yunwoke.com',
      app: 'https://cpic-app.yunwoke.com'
    },
    test: {
      resident: 'https://resident.yunwoke.com',
      yunxun: 'https://yunxun.yunwoke.com',
      ent: 'https://ent.yunwoke.com',
      oss: 'https://oss.yunwoke.com',
      monitor: 'https://monitor.yunwoke.com',
      org: 'https://org2.yunwoke.com',
      oahub: 'https://oahub.yunwoke.com',
      crm: 'https://crm2.yunwoke.com',
      appraise: 'https://appraise.yunwoke.com',
      passport: 'https://passport.yunwoke.com',
      task: 'https://task.yunwoke.com',
      www: 'https://test.yunwoke.com',
      wwwm: 'https://m.yunwoke.com',
      edoc: 'https://edoc.yunwoke.com',
      wssent: 'ws://ent.yunwoke.com/api/feeds/ws',
      wsstask: 'ws://task.yunwoke.com/api/feeds/ws',
      wssresident: 'ws://resident.yunwoke.com/websocket/feeds',
      eam: 'https://eam.yunwoke.com',
      news: 'https://info.yunwoke.com',
      file: 'https://yunxunfile.yunwoke.com',
      code: 'https://code.yunwoke.com',
      app: 'https://app.yunwoke.com'
    }
  };
  var env = getSiteEnv();
  return function (app, _env) {
    return config[_env || env][app] || config[_env || env]['www'];
  };
}();
/**
 * 转换后端传回的日期串
 * @param {*} val 值
 * @param {*} type 格式
 * @param {*} isMillisecond 是否是毫秒
 */

export var getDate = function getDate(val, type, isMillisecond) {
  if (isMillisecond === void 0) {
    isMillisecond = true;
  }

  var time = new Date();

  if (val) {
    time = isMillisecond ? new Date(val * 1000) : new Date(val.toString().replace(/-/g, '/'));
  }

  var year = time.getFullYear().toString();
  var cmonth = time.getMonth() + 1;
  var month = cmonth < 10 ? '0' + cmonth.toString() : cmonth.toString();
  var date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
  var hourN = time.getHours();
  var hour = hourN < 10 ? "0" + hourN : "" + hourN;
  var minutesN = time.getMinutes();
  var minutes = minutesN < 10 ? "0" + minutesN : "" + minutesN;
  var secondsN = time.getSeconds();
  var seconds = secondsN < 10 ? "0" + secondsN : "" + secondsN;
  var result = '';

  switch (type) {
    case 'y.m':
      // 2016.11
      result = year + '.' + month;
      break;

    case 'ym':
      // 2016.11.23
      result = year + '.' + month + '.' + date;
      break;

    case 'md':
      // 11.23
      result = month + '.' + date;
      break;

    case 'hm':
      // 10:56
      result = hour + ':' + minutes;
      break;

    case 'mdhm':
      // 11-23 10:56
      result = month + '-' + date + ' ' + hour + ':' + minutes;
      break;

    case 'hms':
      // 10:56:09
      result = hour + ':' + minutes + ':' + seconds;
      break;

    case 'm':
      // 06
      result = minutes;
      break;

    case 'm-d':
      // 11-23
      result = month + '-' + date;
      break;

    case 'ymhs':
      // 2016.11.23 10:56
      result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes;
      break;

    case 'ymhss':
      // 2016.11.23 10:56:00
      result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes + ':' + seconds;
      break;

    case 'ymdhms':
      // 20161123105600
      result = year + '' + month + '' + date + '' + hour + '' + minutes + '' + seconds;
      break;

    case 'y-mhs':
      // 2016-11-23 10:56
      result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes;
      break;

    case 'ymdhm':
      // 2016-11-23
      result = year + '-' + month + '-' + date;
      break;

    case 'mdyr':
      // 11月23日
      result = month + '月' + date + '日';
      break;

    case 'ymd':
      // 2013年11月23日
      result = year + '年' + month + '月' + date + '日';
      break;

    case 'year':
      // 2016
      result = year;
      break;

    case 'task':
      var now = new Date().getTime();
      var day = new Date().getDate();
      var diff = now - time.getTime();
      result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes;

      if (diff < 86400000) {
        result = time.getDate() - day === 0 ? '今天 ' + hour + ':' + minutes : '昨天 ' + hour + ':' + minutes;
      } else if (diff < 86400000 * 2) {
        result = day - time.getDate() === 1 ? '昨天 ' + hour + ':' + minutes : result;
      }

      break;

    default:
      result = year + '-' + month;
  }

  return result;
};
/**
 * 设置倒计时
 * @param time 当前时间
 * @param before boolean 是否之前
 * @param type getDate中得type类型
 */

export var downTime = function downTime(_time, before, type) {
  var now = new Date().getTime();
  var time = new Date(_time.toString().replace(/-/gi, '/')).getTime();
  var oneDay = 24 * 1000 * 60 * 60;

  if (Math.abs(time - now) > oneDay) {
    var diffDay = Math.floor(Math.abs(time - now) / oneDay);

    if (before) {
      if (Math.abs(time - now) > oneDay * 5) {
        return getDate(time / 1000, type || 'ymd', true);
      } else {
        return diffDay + "\u5929\u524D";
      }
    }

    return '<b>' + diffDay + '</b>天';
  } else {
    var h = void 0;
    var m = void 0;
    var leftTime = Math.abs(time - now);

    if (leftTime >= 0) {
      h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
      m = Math.floor(leftTime / 1000 / 60 % 60);
    }

    if (before) {
      if (h <= 0) {
        if (m < 1) {
          return '刚刚';
        }

        return m + "\u5206\u949F\u524D";
      }

      return h + "\u5C0F\u65F6\u524D";
    }

    return h + "\u5C0F\u65F6" + m + "\u5206";
  }
};
/**
 * 将json对象转换成query string
 *
 * @function
 * @param {object} object 要序列化的数据
 * @param {[object]} options 序列化的可选条件
 * @returns {string} 序列化结果字符串
 */

export var json2QS = function json2QS(object, options) {
  return qs.stringify(object, options);
};
/**
 * 将query string转换成json对象
 *
 * @function
 * @param {string} str
 * @param {object} [options]
 * @returns
 */

export var qs2JSON = function qs2JSON(str, options) {
  return qs.parse(str, options);
};